<template>
  <div>
    <v-list-item>
      <div class="mr-2 py-3 dragHandle"
           title="Drag to reorder the presentations.">
        <v-icon>
          fas fa-fw fa-grip-vertical
        </v-icon>
      </div>
      <div v-if="1===2"
           class="mr-2">
        {{ asset.position }}
      </div>
      <div v-if="asset.presentation && asset.presentation.thumbnail"
           class="mr-2 py-3">
        <v-card>
          <v-img :src="asset.presentation.thumbnail.url"
                 alt="Thumbnail"
                 width="60"
                 height="28"
                 contain/>
        </v-card>
      </div>
      <v-list-item-content :class="form.is_active ? '' : 'text--disabled'">
        <template v-if="asset.is_presentation">
          <v-list-item-title>
            {{ asset.presentation.alias_or_name }}
          </v-list-item-title>
          <v-list-item-subtitle v-if="asset.presentation.alias">
            {{ asset.presentation.alias }}
          </v-list-item-subtitle>
        </template>
        <template v-else>
          <v-list-item-title>
            <v-text-field v-if="edit"
                          v-model="form.name"
                          single-line
                          label="Section name"
                          outlined
                          dense
                          hide-details
                          @keydown.enter="updateName"
                          @blur="updateName">
            </v-text-field>
            <div v-else
                 @click.prevent="edit = true"
                 :class="form.is_active ? 'd-flex font-weight-bold' : 'd-flex text--disabled'"
                 style="cursor: pointer;">
              <div>
                {{ asset.section?.name }}
              </div>
              <v-icon right
                      small>
                fal fa-pencil
              </v-icon>
            </div>
          </v-list-item-title>
        </template>
      </v-list-item-content>
      <div>
        <v-switch v-model="form.is_active"
                  label=""
                  @change="updateStatus"
                  title="Toggle this off to deactivate this link.">
        </v-switch>
      </div>
      <v-list-item-action>
        <v-menu offset-y>
          <template v-slot:activator="{on, attrs}">
            <v-btn text
                   v-bind="attrs"
                   v-on="on">
              <v-icon>
                fas fa-fw fa-ellipsis-h
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click.prevent="addSectionAbove">
              Add section above
            </v-list-item>
            <v-list-item @click.prevent="addSectionBelow">
              Add section below
            </v-list-item>
            <v-list-item v-if="asset.is_presentation"
                         :href="editPresentationURL"
                         target="_blank">
              Edit presentation
            </v-list-item>
            <v-list-item @click.prevent="removeAsset"
                         title="Remove this presentation from the space">
              Remove
            </v-list-item>
          </v-list>
        </v-menu>
      </v-list-item-action>
    </v-list-item>
    <v-divider></v-divider>
  </div>
</template>
<script>
import axios from '../../../services/axiosService';
import {Form} from 'vform';
import DOMPurify from 'dompurify';

export default {
  props: {
    asset: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      edit: false,
      form: new Form({
        is_active: this.asset.is_active,
        name: this.asset.section?.name,
      })
    }
  },
  computed: {
    editPresentationURL() {
      return `/admin/presentations/${this.asset.presentation_id}/edit`;
    }
  },
  methods: {
    addSectionAbove() {
      const form = {
        position: this.asset.position,
      }
      return axios.post(`/api/spaces/${this.asset.space_id}/sections`, form)
        .then(() => {
          this.$emit('updated')
        })
        .catch(() => {
          this.$toast.error('There was a problem creating a section.');
        });
    },
    addSectionBelow() {
      const form = {
        position: this.asset.position + 1,
      }
      return axios.post(`/api/spaces/${this.asset.space_id}/sections`, form)
        .then(() => {
          this.$emit('updated')
        })
        .catch(() => {
          this.$toast.error('There was a problem creating a section.');
        });
    },
    removeAsset() {
      axios.delete(`/api/space-assets/${this.asset.id}`)
        .then(response => {
          if (response.data?.success) {
            this.$emit('removed');
          } else if (response.data?.message) {
            this.$toast.warning(response.data?.message);
          }
        })
        .catch(err => {
          if (err.response?.data?.message) {
            this.$toast.warning(err.response.data.message);
          }
        });
    },
    updateStatus() {
      const form = {
        is_active: this.form.is_active
      }
      axios.put(`/api/space-assets/${this.asset.id}`, form)
        .then(response => {
          if (response.data.is_active) {
            const message = this.asset.is_presentation
              ? 'Link activated.'
              : 'Section activated.';
            this.$toast.success(message);
          } else {
            const message = this.asset.is_presentation
              ? 'Link deactivated.'
              : 'Section deactivated.';
            this.$toast.warning(message);
          }
        })
        .catch(() => {
        });
    },
    updateName() {
      if (this.asset.is_section === false) { // only do this for sections.
        this.edit = false;
        return;
      }
      if (this.asset.section?.name === this.form.name) { // if the name hasn't changed, exit.
        this.edit = false;
        return;
      }
      const form = {
        name: this.form.name,
      }
      this.form.busy = true;
      axios.put(`/api/space-sections/${this.asset.space_section_id}`, form)
        .then(() => {
          this.edit = false;
          this.$emit('updated');
          this.$toast.success('Section updated.');
        })
        .catch(err => {
          if (err.response?.data?.message) {
            this.$toast.error(DOMPurify.sanitize(err.response.data.message));
          } else {
            this.$toast.error('There was an error.');
          }
        })
        .finally(() => {
          this.form.busy = false;
        })
    }
  }
}
</script>
